import React, { useEffect, useState } from 'react'
import { Col, FlexboxGrid, Icon, Panel, Rate, Row } from 'rsuite'
import {
  buildFilteredTree,
  getLabelsWithParents,
  loadLocation,
} from '../../components/location/Location'
import RenderLocationTree, { isAssessmentLocation } from './RenderLocationTree'

export default function RenderAssessmentView({ assessments, ...props }) {
  const [location, setLocation] = useState([])

  useEffect(() => {
    if (isAssessmentLocation(assessments)) {
      handleLocation()
    }
  }, [assessments])

  const handleLocation = async () => {
    // setLoading(true)
    let locationJson = await loadLocation()

    setLocation(locationJson || [])
    // setLoading(false)
  }

  const renderAssessment = (datas, isTab) => {
    return (
      <>
        {datas?.map((data, index) => {
          return (
            <Panel
              bordered
              key={data.id}
              style={{ marginBottom: 10, marginLeft: isTab ? 10 : 0 }}
              collapsible
              defaultExpanded
              header={data.label}
            >
              {data && (
                <>
                  {data.type == '1' && (
                    <>
                      {data.options?.map((item, index) => {
                        return (
                          <p>
                            <Icon
                              icon={data.value == item.value ? 'check-square-o' : 'square-o'}
                              size="lg"
                              style={{ marginRight: 10 }}
                            />
                            <label
                              dangerouslySetInnerHTML={{ __html: item.label }}
                              style={{ marginTop: -3 }}
                            />
                          </p>
                        )
                      })}
                    </>
                  )}
                  {data.type == '2' && (
                    <>
                      {data.options?.map((item, index) => {
                        return (
                          <>
                            <p>
                              <Icon
                                icon={
                                  data.value?.includes(item.value) ? 'check-square-o' : 'square-o'
                                }
                                size="lg"
                                style={{ marginRight: 10 }}
                              />
                              <label
                                dangerouslySetInnerHTML={{ __html: item.label }}
                                style={{ marginTop: -3 }}
                              />
                            </p>
                            {data.value?.includes(item.value) && item.extends?.length > 0 && (
                              <div style={{ marginLeft: 30 }}>
                                {renderAssessment(item.extends, true)}
                              </div>
                            )}
                          </>
                        )
                      })}
                    </>
                  )}
                  {['3', '4', '5'].includes(data.type) && (
                    <>
                      <div
                        dangerouslySetInnerHTML={{ __html: data.value || '-- ไม่ระบุ --' }}
                        style={{ marginTop: -3 }}
                      />
                    </>
                  )}
                  {'6' == data.type && (
                    <>
                      <Row style={{ textAlign: 'center' }}>
                        <Rate
                          defaultValue={data.value || 0}
                          max={data.maximum || 5}
                          classPrefix="rs-rate rs-rate-size-xl"
                          value={data.value || 0}
                        />
                      </Row>
                    </>
                  )}

                  {'7' == data.type && (
                    <>
                      <Row>
                        <ul>
                          {getLabelsWithParents(location, data.value?.split(','))?.map((e) => {
                            return <li key={e}>{e}</li>
                          })}
                        </ul>
                      </Row>
                    </>
                  )}

                  {'8' == data.type && (
                    <>
                      <FlexboxGrid style={{ marginTop: -10 }}>
                        {buildFilteredTree(location, data.value)?.map((node) => (
                          <FlexboxGrid.Item
                            componentClass={Col}
                            colspan={24}
                            lg={6}
                            md={8}
                            sm={12}
                            xs={24}
                          >
                            <RenderLocationTree data={[node]} />
                          </FlexboxGrid.Item>
                        ))}
                      </FlexboxGrid>
                    </>
                  )}

                  {data.type == '9' && (
                    <>
                      <label>
                        {data.options?.find((e) => e.value == data.value)?.label || '-- ไม่ระบุ --'}
                      </label>
                    </>
                  )}

                  {/* {'8' == data.type && (
                    <>
                      <Row>
                        
                        <RenderLocationTree data={buildFilteredTree(location, data.value)} />
                      </Row>
                    </>
                  )} */}
                </>
              )}

              {data.children?.length > 0 && renderAssessment(data.children, true)}
            </Panel>
          )
        })}
      </>
    )
  }
  return <div>{renderAssessment(assessments || [], false)}</div>
}
